/**
 * =============================================================================
 * IDS CRM Web - Shared engineer-status metadata (Batch E UX system)
 * =============================================================================
 *
 * Single source of truth for engineer status labels, colours and CSS classes.
 * Previously triplicated (Layout.js, Engineers.js, EngineerMap.js) with the
 * usual drift risk. Chip rendering lives in components/StatusChip.js.
 *
 * =============================================================================
 */

export const ENGINEER_STATUS_META = {
  available: { label: 'Available', color: '#1D9E75', className: 'status-available' },
  travelling: { label: 'Travelling', color: '#EF9F27', className: 'status-travelling' },
  on_site: { label: 'On Site', color: '#7F77DD', className: 'status-on-job' },
  travelling_home: { label: 'Travelling Home', color: '#B45309', className: 'status-travelling' },
  on_job: { label: 'On Job', color: '#7F77DD', className: 'status-on-job' },
  on_call: { label: 'On Call', color: '#378ADD', className: 'status-on-call' },
  off_duty: { label: 'Off Duty', color: '#9CA3AF', className: 'status-off-duty' },
  annual_leave: { label: 'Annual Leave', color: '#9CA3AF', className: 'status-off-duty' },
  sick: { label: 'Sick', color: '#9CA3AF', className: 'status-off-duty' }
};

export function engineerStatusClass(status) {
  return ENGINEER_STATUS_META[status]?.className || '';
}

export function engineerStatusLabel(status) {
  return ENGINEER_STATUS_META[status]?.label || (status ? String(status).replace(/_/g, ' ') : 'Unknown');
}

export function engineerStatusColor(status) {
  return ENGINEER_STATUS_META[status]?.color || '#9CA3AF';
}
